import { useEffect } from 'react';
import { useCustomNavigate } from './useCustomNavigate';
import { NavigationType, useNavigationType } from 'react-router';

export const useRedirectedOnBack = (redirectPath: string): void => {
  const {navigate} = useCustomNavigate();
  const navigationType = useNavigationType();

  useEffect(() => {
    // check if the user is navigating back
    if (navigationType === NavigationType.Pop) {
      navigate(redirectPath, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, redirectPath]);
};
